import { z } from "zod";

const optionalUrl = z.preprocess((value) => (value === "" ? undefined : value), z.string().url().optional());
const nullableUrl = z.preprocess((value) => (value === "" ? null : value), z.string().url().nullable().optional());
const numericText = z.string().regex(/^\d+(\.\d+)?$/, "Use a non-negative number");
const intText = z.string().regex(/^\d+$/, "Use a whole number");
const optionalIntText = z.preprocess((value) => (value === "" ? undefined : value), intText.optional());

export const partnerAdminSchema = z.object({
  name: z.string().min(1).max(255),
  slug: z.string().min(1).max(100).regex(/^[a-z0-9-]+$/),
  tokenName: z.string().max(50).optional(),
  logo: z.string().url(),
  bannerDesktop: z.string().url(),
  bannerTablet: z.string().url(),
  bannerMobile: z.string().url(),
  titleDescription: z.string().optional(),
  description: z.string().optional(),
  thumbnailImage: z.string().optional(),
  thumbnailTitle: z.string().optional(),
  thumbnailDescription: z.string().optional(),
  thumbnailStartDate: z.string().optional(),
  thumbnailEndDate: z.string().optional(),
  webUrl: optionalUrl,
  xUrl: optionalUrl,
  discordUrl: optionalUrl,
  telegramUrl: optionalUrl,
  instagramUrl: optionalUrl,
  socialBadgeTweetTemplate: z.string().optional(),
  socialBadgeInfoText: z.string().optional(),
  maxMintPerUser: intText,
  maxMintPerVipUser: intText,
  isVerified: z.boolean(),
  isDaoProject: z.boolean(),
  isMarketplaceProject: z.boolean(),
  isTestMode: z.boolean(),
  hasFaucet: z.boolean(),
  faucetConfigId: z.string().optional(),
  featuringPartnerId: z.string().optional(),
});

export const questAdminSchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().optional(),
  image: nullableUrl,
  pointsReward: intText,
  buttonText: z.string().min(1).max(100),
  actionType: z.string().min(1),
  actionParams: z.string().optional(),
  scrapingConfigType: z.string().optional(),
  startDate: z.string().min(1),
  endDate: z.string().min(1),
  ordering: intText,
  isActive: z.boolean(),
});

export const projectAdminSchema = z.object({
  title: z.string().min(1).max(255),
  description: z.string().optional(),
  image: nullableUrl,
  nftCollection: z.string().optional(),
  tokenListId: z.string().optional(),
  eggId: z.string().optional(),
  startDate: z.string().min(1),
  endDate: z.string().min(1),
  isActive: z.boolean(),
  isEggMechanism: z.boolean(),
  isVipSession: z.boolean(),
  isUsingWhitelist: z.boolean(),
  isNeedJoinDao: z.boolean(),
  isNeedVerificationCode: z.boolean(),
});

export const eggAdminSchema = z.object({
  name: z.string().min(1).max(255),
  description: z.string().optional(),
  imageUrl: z.string().url(),
  rarityIds: z.array(z.number()).min(1),
  contractAddress: z.string().optional(),
  maxSupply: intText,
  minted: intText.optional(),
  price: numericText,
  mintFee: numericText,
  protocolFee: numericText,
  priorityFeeTncUrl: z.string().optional(),
  termsAndConditions: z.string().optional(),
  lockToken: numericText,
  lockTokenName: z.string().optional(),
});

export const collectionItemAdminSchema = z.object({
  projectId: z.string().min(1),
  name: z.string().min(1).max(255),
  description: z.string().optional(),
  image: z.string().url(),
  type: z.string().min(1).max(10),
  rarityId: z.string().min(1),
  categoryId: z.string().min(1),
  eggId: z.string().optional(),
  traitStackingConfigId: optionalIntText,
  baseImageUrl: nullableUrl,
  contractUrl: nullableUrl,
  thumbnail: nullableUrl,
  maxMinted: intText,
  lockToken: numericText,
  lockTokenFee: numericText,
  lockTokenName: z.string().optional(),
  nftCollection: z.string().optional(),
  price: numericText,
  mintFee: numericText,
  protocolFee: numericText,
  priorityFeeTncUrl: nullableUrl,
});

export const rarityAdminSchema = z.object({
  title: z.string().min(1).max(255),
  name: z.string().min(1).max(100),
  rarityChance: numericText,
  image: z.string().optional(),
});

export const categoryAdminSchema = z.object({
  name: z.string().min(1).max(100),
});
